import { apiClient } from '@/lib/api/api-client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type { ExchangeSummaryResponse } from '../types/exchange-rate.types';

export interface DashboardStats {
  quotes: {
    total: number;
    draft: number;
    pendingApproval: number;
    approved: number;
    rejected: number;
    expired: number;
    /** Canceladas: van aparte, no cuentan como activas ni como perdidas. */
    cancelled?: number;
  };
  revenue: {
    totalApproved: number;
    avgDealSize: number;
    totalPending: number;
    totalLost: number;
    lostCount: number;
  };
  models: {
    total: number;
    active: number;
  };
  approvals: {
    pending: number;
    avgResolutionHours: number;
  };
  recentQuotes: {
    id: string;
    code: string;
    clientName: string;
    status: string;
    finalPrice: number;
    currencyCode: string;
    createdAt: string;
    createdBy: string;
  }[];
  notApprovedQuotes: {
    id: string;
    code: string;
    clientName: string;
    status: string;
    finalPrice: number;
    currencyCode: string;
    createdAt: string;
    createdBy: string;
  }[];
  expiringSoonQuotes: {
    id: string;
    code: string;
    clientName: string;
    status: string;
    finalPrice: number;
    currencyCode: string;
    createdAt: string;
    createdBy: string;
    validUntil: string;
    daysLeft: number;
  }[];
  quotesByMonth: {
    month: string;
    count: number;
    revenue: number;
  }[];
  comparison: {
    current: {
      total: number;
      approved: number;
      pending: number;
      lost: number;
      revenue: number;
    };
    previous: {
      total: number;
      approved: number;
      pending: number;
      lost: number;
      revenue: number;
    };
  };
  topClients: {
    name: string;
    revenue: number;
    count: number;
  }[];
  forecast: {
    winRate: number;
    totalPending: number;
    forecastedRevenue: number;
  };
  closeMetrics: {
    avgClosingDays: number;
    winRateByMonth: {
      month: string;
      winRate: number;
    }[];
  };
  marginMetrics: {
    avgMargin: number;
    buckets: { label: string; count: number }[];
    sampleSize: number;
  };
  topModels: {
    id: string;
    name: string;
    revenue: number;
    count: number;
  }[];
  dealSizeDistribution: {
    label: string;
    count: number;
    revenue: number;
  }[];
  discountMetrics: {
    approvedCount: number;
    discountedCount: number;
    discountedPct: number;
    avgDiscountPct: number;
    totalDiscountAmount: number;
    largestDeal: number;
  };
}

export const dashboardService = {
  getStats: () => apiClient.get<DashboardStats>(ENDPOINTS.DASHBOARD_STATS),
  getExchangeSummary: () =>
    apiClient.get<ExchangeSummaryResponse>(ENDPOINTS.CURRENCY_EXCHANGE_SUMMARY),
};
